export enum TagType {
	MetaTag = 'MetaTag',
	MetaData = 'MetaData',
}

export class TagModel {
	type: TagType;

	key: string;
	value: string;
	visible: boolean;

	constructor(init?: Partial<TagModel>) {
		Object.assign(this, init);
	}
}
